<template>
  <div class="pa-6" style="width: 100%">
    <ConfirmLeadDialog
      :state="confirmLeadDialog"
      @closeDialog="closeConfirmDialog"
      @updateResult="onUpdateResultDocument"
    />
    <CreateLeadForm :state="createLeadDialog" :users="users" @closeDialog="closeCreate" @refresh="updateFinished" />
    <LeadProgressDialog :state="progressDialog" @finish="progressFinish" @closeDialog="closeProgress" />
    <ConfirmUpdateDialog :items="existedList" @finished="updateFinished" />
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Khách hàng tiềm năng</div>
      <div class="d-flex flex-center">
        <ExportExcel />
      </div>
    </div>
    <div class="d-flex justify-end align-center mb-6">
      <ImportExcelSample />
      <ImportExcel
        ref="excel-import"
        @onImportSuccess="() => (confirmLeadDialog = true)"
        @openProgressDialog="() => (progressDialog = true)"
        @fillExistedList="val => (existedList = val)"
      />
      <v-btn color="primary" class="elevation-0 ml-6" dark @click="createLead"> Tạo khách hàng </v-btn>
    </div>
    <v-card outlined class="pa-6 elevation-0 mb-6">
      <LeadFilter :users="users" @onFilterChanged="onFilterChanged" />
    </v-card>

    <LeadTable ref="leadTable" :query="filterQuery" />
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapActions, mapGetters } from 'vuex'
import LeadFilter from './LeadFilter.vue'
import LeadTable from './LeadTable.vue'
import ConfirmLeadDialog from './ConfirmLeadDialog.vue'
import ConfirmUpdateDialog from './ConfirmUpdateDialog.vue'
import CreateLeadForm from '@/components/basic/form/CreateLeadForm.vue'
import utils from '@/plugins/utils'
import { Lead } from '@/plugins/api'
import LeadProgressDialog from './LeadProgressDialog.vue'
import ImportExcelSample from './leadList/excel/ImportSample.vue'
import ExportExcel from './leadList/excel/ExportExcel.vue'
import ImportExcel from './leadList/excel/ImportExcel.vue'

export default {
  components: {
    LeadFilter,
    LeadTable,
    ConfirmLeadDialog,
    ConfirmUpdateDialog,
    CreateLeadForm,
    LeadProgressDialog,
    ImportExcelSample,
    ImportExcel,
    ExportExcel,
  },
  data() {
    return {
      confirmLeadDialog: false,
      createLeadDialog: false,
      progressDialog: false,
      existedList: [],
      users: [],
      filterQuery: {},
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
  },
  async mounted() {
    this.setImportedItems([])
    await this.fetchLeadConfig()
    this.fetchProducts()
    this.getUsers()
  },
  methods: {
    ...mapActions('lead', ['createLead', 'fetchLeads']),
    ...mapActions('product', ['fetchProducts']),
    ...mapActions('user', ['fetchUsers']),
    ...mapActions({ fetchLeadConfig: 'leadConfig/fetchConfigs', setImportedItems: 'lead/setImportedItems' }),
    closeConfirmDialog() {
      this.confirmLeadDialog = false
      this.$refs['excel-import'].reset()
    },
    progressFinish(data) {
      if (data) this.existedList = data.existedList
    },
    closeProgress() {
      this.progressDialog = false
    },
    async onUpdateResultDocument(data = []) {
      this.$refs['excel-import'].reset()
      let existLeadList = []
      this.existedList = []
      const leads = []
      for (const lead of data) {
        lead.inCharge = [this.user.id]
        lead.createdBy = this.user.id
        lead.createdByName = this.user.name
        lead.studentNameSearchField = utils.removeUnicode(lead.studentName).toLowerCase()
        lead.studentSchoolSearchField = utils.removeUnicode(lead.studentSchool).toLowerCase()
        lead.studentNameSearchField = utils.removeUnicode(lead.studentName).toLowerCase()
        leads.push(lead)
      }
      if (leads.length > 0) {
        const leadRequest = await Lead.createManyLead(leads)
        if (!leadRequest) {
          this.$alert.error('Lỗi tải file lên. Xin vui lòng thử lại')
          this.confirmLeadDialog = false
          this.$refs.leadTable.refresh()
        } else {
          this.progressDialog = true
        }
      }

      this.existedList = existLeadList
      existLeadList = []
      this.$alert.success('Đã tạo khách hàng thành công')
      this.confirmLeadDialog = false
      this.$refs.leadTable.refresh()
    },
    onFilterChanged(query) {
      this.filterQuery = query
    },
    async getUsers() {
      this.users = await this.fetchUsers({ role_in: ['682d7c93f9f6e40d0ab0324e', '6569abe679c575d1488858f2'] })
    },
    createLead() {
      this.createLeadDialog = true
    },
    closeCreate() {
      this.createLeadDialog = false
    },
    updateFinished() {
      this.$refs.leadTable.refresh()
    },
  },
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
